import React from "react";
import "./Unsubcribe.css";
import {
  faClipboardQuestion,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import Contact_details_card from "../common_components/contact_details_card/Contact_details_card";

function Unsubcribe() {
  return (
    <>
      <section className="Legal_notice">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-8">
              <div className="content_box_holder">
                <div className="heading_strip_holder">
                  <h1>UNSUBSCRIBE</h1>
                </div>
              </div>

              <div className="content_box_holder">
                <div className="content_holder">
                  <div className="text_holder">
                    <p>Last updated Wednesday, April 9, 2025</p>
                    <h4>Unsubscribe from Mittal Craftworks Emails</h4>
                    <hr />
                    <h6>1. Confirm Your Unsubscribe</h6>
                    <p>
                      By clicking the button below, you will be removed from all
                      future Mittal Craftworks promotional mailing lists.
                    </p>
                     <hr />
                    <div className="list_holder">
                      <h5>2. We Value Your Input (Optional)</h5>
                      <p>
                        Help us improve! We'd appreciate it if you could briefly
                        share your reason for leaving:
                      </p>
                      <ul>
                        <li>
                          <p>
                            <Form>
                              <Form.Group className="mb-3">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control
                                  type="email"
                                  placeholder="Enter Email Address*"
                                />
                              </Form.Group>
                              <div className="mb-3">
                                <Form.Check
                                  label="YES, UNSUBSCRIBE ME"
                                  name="group1"
                                  type={"checkbox"}
                                />
                              </div>
                            </Form>
                          </p>
                        </li>
                      </ul>

                      <p>
                        <span className="text-danger text_decoration_holder"><b>Please Note: </b></span> It
                        may take up to 72 hours for your request to be fully
                        processed across all our systems. You may receive one or
                        two scheduled emails during this brief period.
                      </p>
                    </div>

                    {/*<hr />

                    <div className="list_holder">
                      <h5>2. We Value Your Input (Optional)</h5>
                      <p>
                        Help us improve! We'd appreciate it if you could briefly
                        share your reason for leaving:
                      </p>
                      <Form>
                        <ul>
                          <li>
                            <p>
                              <div className="mb-3">
                                <Form.Check
                                  label="Too many emails."
                                  name="group1"
                                  type={"radio"}
                                />
                              </div>
                            </p>
                          </li>

                          <li>
                            <p>
                              <div className="mb-3">
                                <Form.Check
                                  label="Content is not relevant to my interests."
                                  name="group1"
                                  type={"radio"}
                                />
                              </div>
                            </p>
                          </li>

                          <li>
                            <p>
                              <div className="mb-3">
                                <Form.Check
                                  label="I'm no longer interested in shopping."
                                  name="group1"
                                  type={"radio"}
                                />
                              </div>
                            </p>
                          </li>

                          <li>
                            <p>
                              <div className="mb-3">
                                <Form.Check
                                  label="Other. (Please Specify)"
                                  name="group1"
                                  type={"radio"}
                                />
                              
                                <Form.Group className="mb-4">
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Type here..."
                                  />
                                </Form.Group>
                              </div>
                            </p>
                          </li>
                        </ul>
                      </Form>
                    </div> 

                    <hr />
                    <div className="list_holder">
                      <h5>3. Important Account Notifications</h5>
                      <p>
                        Please be aware that unsubscribing only stops marketing
                        and promotional emails.
                      </p>
                      <ul>
                        <li>
                          <p>
                            You will still receive essential emails related to
                            the status of your account and orders, such as:
                          </p>
                        </li>

                        <li>
                          <p>Order confirmations and tracking updates </p>
                        </li>

                        <li>
                          <p>Password resets or security alerts </p>
                        </li>

                        <li>
                          <p>Terms of Service updates</p>
                        </li>
                      </ul>
                    </div>*/}

                    <hr />
                    <div className="list_holder">
                      <h5>4. Need Assistance?</h5>
                      <p>
                        If you unsubscribed by accident or have questions about
                        your account, please contact us:
                      </p>
                      <ul>
                        <li>
                          <p>Monday to Saturday 10:00 am - 06:00 pm IST</p>
                        </li>

                        <li>
                          <p>
                            <span>+91 93029 11233 / +91 731 6711 800 </span>
                          </p>
                        </li>

                        <li>
                          <p>
                            Email Us: <span>sales@mittalcraftworks.com</span>{" "}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
            <Contact_details_card/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Unsubcribe;
